import React, {memo, useMemo} from "react";
import {useAuthenticationContext} from "@utils/auth/AuthenticationContext";
import FlintDropDownList from "@components/controls/FlintDropDownList";
import {ApiResponseDto, DropDownListItem, NameWithId, VivoRootModel} from "@utils/Models";
import axios, {AxiosError} from "axios";
import styles from "./LabSelector.module.scss";

import {
    ApiUrl_Common_SwitchLab,
} from "@utils/Endpoints";
import {useFlintNotificationContext} from "./notifications/FlintNotificationContext";
import useMediaQuery from "@utils/other/useMediaQuery";
import {mediaQueries} from "@utils/AppConstants";

const LabSelector = function LabSelector() {
    // console.log("lab selector rendered")
    const {state, utils, handlers} = useLabSelector();
    
    if (!state.labList.get) {
        return <div></div>;
    }
    
    return (
        <>
            {utils.isDesktop ?
                <FlintDropDownList className={styles.labSelectorDropDown}
                                   dataSource={state.labList.get}
                                   onItemSelected={handlers.handleLabSelected}
                                   usePrimitives={true}
                                   selectedValue={state.selectedLabId.get}/>
                :
                <FlintDropDownList<DropDownListItem> style={{minWidth: "30px"}}
                                                     className={styles.mobileLabSelectorDropDown}
                                                     dataSource={state.labList.get}
                                                     onItemSelected={handlers.handleLabSelected}
                                                     usePrimitives={true}
                                                     selectedValue={state.selectedLabId.get}/>}
        </>
    )
}

function useLabSelector() {
    const {claims, rootModel, update} = useAuthenticationContext();
    const {showNotification} = useFlintNotificationContext();
    const isLgUp = useMediaQuery(mediaQueries.lg_Up);
    async function handleLabSelected(newLab: DropDownListItem) {
        try {
            let model = await axios.post<ApiResponseDto<VivoRootModel>>(ApiUrl_Common_SwitchLab, JSON.stringify(newLab.Id));
            update(claims, model.data.Result);
        } catch (e: any) {
            showNotification(e);
        }
    }
    const labList = useMemo(() => {
        return isLgUp ? rootModel?.LabData.LabList : rootModel?.LabData.LabList.map((lab) => (
            {
                Name: lab.Extension,
                Id: lab.Id
            } as DropDownListItem));
    }, [isLgUp, rootModel?.CurrentUserProfile.DivisionList])
    return {
        state: {
            labList: {get: labList},
            selectedLabId: {get: rootModel?.CurrentUserProfile.LabId},
        },
        utils: {
            isDesktop: isLgUp,
        },
        handlers: {
            handleLabSelected
        }
    }
}

export default memo(LabSelector); 